import React from 'react';
import { Stack, Flex, Box } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@landsvirkjun/react.common';

type ActionBarProps = {
  onOpen?: () => void;
  onEditRequest?: () => void;
  primaryBtnText: string | null;
  primaryBtnOnClick?: () => void;
  secondaryBtnText: string;
  secondaryBtnOnClick?: () => void;
  secondaryBtnVariant: 'primary' | 'secondary' | 'warning';
  disablePrimaryBtn?: boolean;
  isLoading?: boolean;
  showActionButtons?: boolean;
  allowEditRequest?: boolean;
  editMode: boolean;
};

export const ActionBar = ({
  onOpen,
  onEditRequest,
  primaryBtnText,
  primaryBtnOnClick,
  secondaryBtnText,
  secondaryBtnOnClick,
  secondaryBtnVariant = 'secondary',
  disablePrimaryBtn,
  isLoading = true,
  showActionButtons = false,
  allowEditRequest = false,
  editMode = false,
}: ActionBarProps): JSX.Element => {
  const navigate = useNavigate();
  return (
    <Flex
      flexWrap={{ base: 'wrap', md: 'nowrap' }}
      justify="space-between"
      pt={5}
      pb={5}
      backgroundColor="white"
      direction="row"
      position="fixed"
      bottom="0"
      left="0"
      right="0"
      padding={'20px 25px'}
      zIndex={1}
      boxShadow={'0 0 20px rgba(0, 0, 0, 0.15)'}
    >
      <Box>
        <Button
          type="button"
          variant="secondary"
          onClick={(): void => navigate(-1)}
        >
          Til baka í yfirlit
        </Button>
      </Box>
      {showActionButtons && (
        <Box flexGrow={{ base: 1, md: 0 }} marginLeft="auto">
          <Stack direction="row" style={{ float: 'right' }}>
            <Button
              type="button"
              variant={secondaryBtnVariant}
              name="save-form"
              onClick={secondaryBtnOnClick || onOpen}
            >
              {secondaryBtnText}
            </Button>
            {allowEditRequest && (
              <Button
                type="button"
                variant={secondaryBtnVariant}
                name="save-form"
                onClick={onEditRequest}
              >
                Breyta beiðni
              </Button>
            )}
            <Button
              minWidth="150px"
              variant="primary"
              loadingText="Augnablik..."
              isLoading={isLoading}
              onClick={primaryBtnOnClick}
              isDisabled={disablePrimaryBtn}
            >
              {primaryBtnText && primaryBtnText}
            </Button>
          </Stack>
        </Box>
      )}
    </Flex>
  );
};
